var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f9b869;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #f37e72;\n      }\n\n      .cls-4 {\n        fill: #ffc5c0;\n      }\n\n      .cls-5 {\n        fill: #b3d7ff;\n      }\n\n      .cls-6 {\n        fill: #330434;\n      }\n\n      .cls-7 {\n        fill: #d17613;\n      }\n\n      .cls-8 {\n        fill: #39003c;\n      }\n\n      .cls-9 {\n        fill: #70acfb;\n      }\n\n      .cls-10 {\n        fill: #773e0e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 119.93,
    cy: 111.44,
    r: 90
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.93,205.44c-51.83,0-94-42.17-94-94S68.1,17.44,119.93,17.44s94,42.17,94,94-42.17,94-94,94Zm0-180c-47.42,0-86,38.58-86,86s38.58,86,86,86,86-38.58,86-86S167.36,25.44,119.93,25.44Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_330",
    "data-name": "Groupe 330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1311",
    "data-name": "Trac\\xE9 1311",
    className: "cls-10",
    d: "M109.22,10.91l-9.26,4.01-13.89,3.19-11.94,12.28v-4.98l-5.12,7.73-1.95,10.03-7.23,6.66,2.53,10.43v4.92l3.5,2.79v12.9l4.31,11.8h17.01l16.15-32.22,48.83,18.23,5.45-8.14,2.23-5.11-1.64-11.63,2.68-10.19-7.52-9.8-6.07-3.4,3.1-6.8-11.9-5.53-12.1-.65v-4.29l-17.17-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1312",
    "data-name": "Trac\\xE9 1312",
    className: "cls-4",
    d: "M80.33,55.5l4.37,15.09-2.21,17.55h-6.47l-7.17-7.27-7.86,1.39-5.09,10.17,6.01,15.95,9.98,4.55,11.24-13.01,12.92,9.97,17.52,5.75,13.02-1.83,25.64,.78,1.95-4.58,4.16-19.65-1.39-18.04-1.5-9.47-9.56-12.66-12.49,4.84-20.07-1.4-18.61-4.91-14.39,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1313",
    "data-name": "Trac\\xE9 1313",
    className: "cls-4",
    d: "M76.12,142.34l-2.26,17.33,12.81,8.34,23.32,7.9,16.32-3.73-1.27-9.73-38.77-13.8-9.04-14.53-1.1,8.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_329",
    "data-name": "Groupe 329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_328",
    "data-name": "Groupe 328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1314",
    "data-name": "Trac\\xE9 1314",
    className: "cls-6",
    d: "M133.86,87.15c.84,.81,1.61,1.68,2.32,2.6,.72,.9,1.37,1.84,2.01,2.79l.12,.18,.08,.12c.05,.08,.1,.16,.14,.25,.15,.3,.23,.63,.24,.96,.01,.46-.07,.92-.24,1.35-.25,.63-.6,1.23-1.01,1.77-.74,.99-1.64,1.85-2.67,2.54l-.91-.83c.5-1.04,1.07-2.03,1.54-2.98,.22-.43,.4-.87,.53-1.33,.04-.11,.05-.23,.05-.35,0,.04,.01,.09,.04,.13,0,.02,.02,.04,.04,.06,.02,.02-.03-.05-.04-.07l-.12-.18c-.64-.98-1.27-1.97-1.83-3-.58-1.03-1.09-2.09-1.52-3.19l1.23-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1315",
    "data-name": "Trac\\xE9 1315",
    className: "cls-7",
    d: "M82.49,88.14l.71,9.63,8.73,5.44,7.09,5.06h9.87l12.94-1.01,8.2-2.78,6.5,.13,5.77,1.77,3.67,3.42,7.52,3.08,1.72,4.01-1.39,7.34-.25,8.61-5.82,7.25-10.63,3.89-8.5,1.42h-19.85l-15.19-8.13-7.09-7.59-4.56-2.4-5.69-10.5v-11.27l-.23-17.35h6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1316",
    "data-name": "Trac\\xE9 1316",
    className: "cls-2",
    d: "M64.43,109.48l1.58,.72-.46,2.41,1.21,2.31,2.37-1.04,.92-3.93-.52-2.31,2.02,3.64-.92,3.64-3.29,2.54-3.58-1.96-.29-3.87,.96-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1317",
    "data-name": "Trac\\xE9 1317",
    className: "cls-6",
    d: "M112.1,81.74c1.53-2.16,4.2-3.21,6.79-2.67,4.73,.72,6.38,3.6,5.14,7.1s-3.39,4.83-5.25,3.7-2.97-1.47-2.37-6.17c-2.88,0-5.25,1.54-5.14,.41,.13-.83,.41-1.63,.82-2.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1318",
    "data-name": "Trac\\xE9 1318",
    className: "cls-6",
    d: "M143.6,83.23c1.41-1.99,3.86-2.95,6.25-2.46,4.35,.66,5.87,3.31,4.73,6.53s-3.12,4.45-4.83,3.41-2.73-1.35-2.18-5.68c-2.65,0-4.83,1.42-4.73,.38,.12-.77,.37-1.5,.76-2.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1319",
    "data-name": "Trac\\xE9 1319",
    className: "cls-6",
    d: "M70.5,104.47s3.47-.87,3.35-6.32-7.19-9.93-8.8-8.25,5.33,3.98,4.96,7.11-3.1,8.33,.5,7.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1320",
    "data-name": "Trac\\xE9 1320",
    className: "cls-10",
    d: "M140.84,69.14s8.69-2.77,13.3-1.22,5.9,4.01,5.9,4.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1321",
    "data-name": "Trac\\xE9 1321",
    className: "cls-10",
    d: "M104.83,69.69s8.11-4.19,12.91-3.43,6.49,2.96,6.49,2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1322",
    "data-name": "Trac\\xE9 1322",
    className: "cls-2",
    d: "M121.67,111.82s13.58-.41,16.85,0-.1,5.21-1.33,6.43-6.54,2.15-9.91,.51-8.48-4.6-5.62-6.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1323",
    "data-name": "Trac\\xE9 1323",
    className: "cls-1",
    d: "M151.32,35.71l-34.21-3.58-33.27,15.84-14.84,27.85v35.28l13.11,23.48,29.03,18.65,32.41-.06,31.55-19.35,8.2-48.14-8.65-27.99-23.33-21.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1324",
    "data-name": "Trac\\xE9 1324",
    className: "cls-6",
    d: "M89.23,76.1l9.89-12.12,18.72-3.52-17.14,6.15-11.47,9.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1325",
    "data-name": "Trac\\xE9 1325",
    className: "cls-6",
    d: "M172.53,80.92l-8.66-13.02-18.29-5.33,16.46,7.79,10.49,10.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1326",
    "data-name": "Trac\\xE9 1326",
    className: "cls-6",
    d: "M93.77,84.66s7.28-12.09,16.6-10.9c9.32,1.19,19.23,15.15,14.59,14.37s-9.36-10.88-14.21-10.24-13.03,9.63-14.94,9.1-3.01-.88-2.04-2.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1327",
    "data-name": "Trac\\xE9 1327",
    className: "cls-6",
    d: "M167.5,87.99s-5.82-12.5-14.37-11.87-18.46,13.97-14.2,13.46,9.21-10.29,13.58-9.37,11.2,10.39,12.98,9.97,2.8-.7,2.01-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1328",
    "data-name": "Trac\\xE9 1328",
    className: "cls-2",
    d: "M169.92,104.27c-.69,4.36-1.99,8.61-3.86,12.6-4.26,9.17-12.98,19.92-30.38,19.43-27.93-.78-37.84-14.57-41.32-25.08-1.31-3.84-1.93-7.87-1.85-11.92,0,0,30.89,10.95,48.8,9.45,26.91-2.25,28.61-4.48,28.61-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1329",
    "data-name": "Trac\\xE9 1329",
    className: "cls-6",
    d: "M166.07,116.87c-4.26,9.17-12.98,19.92-30.38,19.43-27.93-.78-37.84-14.57-41.32-25.08,6.92,2.31,31.65,10.1,46.95,8.82,13.89-1.16,21.06-2.32,24.75-3.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1330",
    "data-name": "Trac\\xE9 1330",
    className: "cls-9",
    d: "M93.57,87.19l-26.91,12.39-8.48,12.48,6.6,15.5,20.33,2.54,7.05-15.35,1.4-27.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1331",
    "data-name": "Trac\\xE9 1331",
    className: "cls-9",
    d: "M167.77,88.85l22.02,13,7.14,12.65-4.96,15.29-16.35,2.04-6.06-15.48-1.8-27.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1332",
    "data-name": "Trac\\xE9 1332",
    className: "cls-5",
    d: "M63.57,113.18l3.35,10.59,4.03-1.33,.72-6.55-3.22-2.76-4.88,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1333",
    "data-name": "Trac\\xE9 1333",
    className: "cls-5",
    d: "M189.93,122.82l-2.49,3.35,2.49,1.06,1.53-2.2-1.53-2.21Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerd);
export default __webpack_public_path__ + "static/media/perd.d509586fd07dc92cc1ce80cd6906f482.svg";
export { ForwardRef as ReactComponent };